import React from "react";
import Header from "../../../Dashboard/Components/ShareElements/ContentHeader/ContentHeader";
import Circle from "../../../../Assets/Images/sm-Circle.svg";
import { BrowserRouter, Switch, Route, NavLink } from "react-router-dom";
import "../../../../Assets/Styles/AI.scss";
import Employees from "../../../Dashboard/Components/AI/DataImportHistory/Employees";
import Positions from "../../../Dashboard/Components/AI/DataImportHistory/Positions";
import Projects from "../../../Dashboard/Components/AI/DataImportHistory/Projects";
import Activities from "../../../Dashboard/Components/AI/DataImportHistory/Activities";
import Skills from "../../../Dashboard/Components/AI/DataImportHistory/Skills";
import Trainings from "../../../Dashboard/Components/AI/DataImportHistory/Trainings";

const DataImportHistory = (props) => {
  const validateNavigation = (e, Id) => {
    transformIndicator(Id);
  };
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  const transformIndicator = (Id) => {
    if (Id === "positions") {
      document.getElementById("animated-indicator").style.transform =
        "translateX(133px)";
    } else if (Id === "employees") {
      document.getElementById("animated-indicator").style.transform = "none";
    } else if (Id === "projects") {
      document.getElementById("animated-indicator").style.transform =
        "translateX(266px)";
    } else if (Id === "activities") {
      document.getElementById("animated-indicator").style.transform =
        "translateX(400px)";
    } else if (Id === "skills") {
      document.getElementById("animated-indicator").style.transform =
        "translateX(530px)";
    } else if (Id === "trainings") {
      document.getElementById("animated-indicator").style.transform =
        "translateX(664px)";
    }
  };
  return (
    <BrowserRouter basename="/home/dataImportHistory">
      <div className="main-content security-settings ai">
        <Header PageName={translateText("data_import_history")} />
        <div className="content-header">
          <div className="address">
            <p>AI</p>
            <img src={Circle} alt="." />
            <p>{translateText("data_import_history")}</p>
          </div>
        </div>
        <div className="actions navigator navigator-large">
          <span id="animated-indicator"></span>
          <NavLink
            onClick={(e) => validateNavigation(e, "employees")}
            activeClassName="active-nav-node"
            exact
            id="employees"
            to="/"
          >
            <p>{translateText("employees")}</p>
          </NavLink>
          <NavLink
            onClick={(e) => validateNavigation(e, "positions")}
            activeClassName="active-nav-node"
            to="/positions"
            id="positions"
          >
            <p>{translateText("positions")}</p>
          </NavLink>
          <NavLink
            onClick={(e) => validateNavigation(e, "projects")}
            activeClassName="active-nav-node"
            id="projects"
            to="/projects"
          >
            <p>{translateText("projects")}</p>
          </NavLink>
          <NavLink
            onClick={(e) => validateNavigation(e, "activities")}
            activeClassName="active-nav-node"
            to="/activities"
            id="activities"
          >
            <p>{translateText("activities")}</p>
          </NavLink>
          <NavLink
            onClick={(e) => validateNavigation(e, "skills")}
            activeClassName="active-nav-node"
            id="skills"
            to="/skills"
          >
            <p>{translateText("skills")}</p>
          </NavLink>
          <NavLink
            onClick={(e) => validateNavigation(e, "trainings")}
            activeClassName="active-nav-node"
            to="/trainings"
            id="trainings"
          >
            <p>{translateText("trainings")}</p>
          </NavLink>
        </div>
        <Switch>
          <Route path="/positions" exact>
            <Positions LangData={props.LangData} />
          </Route>
          <Route path="/projects" exact>
            <Projects LangData={props.LangData} />
          </Route>
          <Route path="/activities" exact>
            <Activities LangData={props.LangData} />
          </Route>
          <Route path="/skills" exact>
            <Skills LangData={props.LangData} />
          </Route>
          <Route path="/trainings" exact>
            <Trainings LangData={props.LangData} />
          </Route>
          <Route path="/" exact>
            <Employees LangData={props.LangData} />
          </Route>
        </Switch>
      </div>
    </BrowserRouter>
  );
};
export default DataImportHistory;
